import axios from 'axios';

const API_BASE = '/videoEdit';

/**
 * 获取当前用户的自定义模板列表
 */
export async function getTemplateList() {
  const res = await axios.get(`${API_BASE}/template/list`);
  if (res.data.code !== 200) {
    throw new Error(res.data.desc || '获取模板列表失败');
  }
  return res.data.data || [];
}

/**
 * 保存/更新模板（upsert）
 */
export async function saveTemplate(template) {
  console.log('saveTemplate called with:', template);
  const res = await axios.post(`${API_BASE}/template/save`, template);
  console.log('saveTemplate response:', res.data);
  if (res.data.code !== 200) {
    throw new Error(res.data.desc || '保存模板失败');
  }
  return res.data.data;
}

/**
 * 软删除模板
 */
export async function deleteTemplate(templateName) {
  console.log('deleteTemplate called with:', templateName);
  if (!templateName) {
    throw new Error('模板名称不能为空');
  }
  const res = await axios.post(`${API_BASE}/template/delete`, null, {
    params: { templateName }
  });
  console.log('deleteTemplate response:', res.data);
  if (res.data.code !== 200) {
    throw new Error(res.data.desc || '删除模板失败');
  }
  return res.data.data;
}

/**
 * 创建任务
 */
export async function createTask(task) {
  const res = await axios.post(`${API_BASE}/task/create`, task);
  if (res.data.code !== 200) {
    throw new Error(res.data.desc || '创建任务失败');
  }
  return res.data.data;
}

/**
 * 获取任务列表（可选按状态过滤）
 */
export async function getTaskList(status) {
  const params = {};
  if (status) {
    params.status = status;
  }
  const res = await axios.get(`${API_BASE}/task/list`, { params });
  if (res.data.code !== 200) {
    throw new Error(res.data.desc || '获取任务列表失败');
  }
  return res.data.data || [];
}

/**
 * 执行视频合成
 */
export async function composeVideo(formData) {
  const res = await axios.post('/video/compose', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  if (res.data.code !== 200) {
    throw new Error(res.data.desc || '视频合成失败');
  }
  return res.data.data;
}

/**
 * 更新任务状态和视频URL
 */
export async function updateTaskStatus(taskName, status, videoUrl, errorMessage) {
  const res = await axios.post(`${API_BASE}/task/update`, {
    taskName,
    status,
    videoUrl,
    errorMessage,
  });
  if (res.data.code !== 200) {
    throw new Error(res.data.desc || '更新任务状态失败');
  }
  return res.data.data;
}
